import { useNavigate } from 'react-router';
import { useAuth } from '@/lib/auth/use-auth';
import { Button } from '@/lib/ui';
import { timeAgo } from '@/lib/utils/format';
import { markAllRead, markRead } from './api';
import { useMyNotifications } from './hooks';

const ICON = { error: '!', warn: '⚠', info: 'i', success: '✓' } as const;

export function NotificationPanel({ open, onClose }: { open: boolean; onClose: () => void }) {
  const navigate = useNavigate();
  const { profile } = useAuth();
  const { data } = useMyNotifications(profile?.uid ?? null);
  const openItem = async (id: string, link: string | null) => {
    await markRead(id);
    onClose();
    if (link) navigate(link);
  };
  return (
    <div id="notif-panel" className={open ? 'open' : ''} role="dialog" aria-label="Notifications" aria-modal="true" aria-hidden={!open} inert={!open}>
      <div className="notif-header">
        <span style={{ fontWeight: 700, fontSize: 14 }}>Notifications</span>
        <span><Button size="sm" variant="ghost" onClick={() => markAllRead(data)}>Mark all read</Button><Button size="sm" variant="ghost" onClick={onClose}>Close</Button></span>
      </div>
      <div className="notif-list">
        {data.length === 0 ? <div className="empty-state">You're all caught up.</div> : data.map((n) => (
          <button type="button" key={n.id} className="notif-item" style={{ opacity: n.read ? 0.6 : 1, cursor: 'pointer', width: '100%', textAlign: 'left', background: 'none', border: 0, font: 'inherit', color: 'inherit' }} onClick={() => openItem(n.id, n.link)}>
            <span className={`notif-icon ${n.type}`}>{ICON[n.type]}</span>
            <div><div className="notif-msg">{n.msg}</div><div className="settings-desc">{n.sub}</div><div className="notif-time">{n.createdAt ? timeAgo(n.createdAt.toDate()) : ''}</div></div>
          </button>
        ))}
      </div>
    </div>
  );
}
